import React, {useEffect, useState} from 'react'
import {createClickableLink} from "../../../../components/common/datatable/DataTableUtils";
import {SearchInputWrapper} from "../../../../components/common/datatable/filter/SearchInputWrapper";
import {DataTable} from "../../../../components/common/datatable/DataTable";
import {DataTableColumn} from "../../../../components/common/datatable/DataTableTypes";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import {useLazyExportStateCodeDataQuery, useSearchAllStateCodesQuery} from "../stateCodeApi";
import IconButton from "../../../../components/common/form/IconButton";
import {FaPlus} from "react-icons/fa6";
import {useNavigate} from "react-router-dom";
import {useFindUserSettingsByGroupNameQuery} from '../../../../components/common/userSetting/userSettingsApi';

function StateCodes() {

    const {data: userSetting} = useFindUserSettingsByGroupNameQuery("StateCode");

    const [crumbs] = useState([
        {content: "Home", url: "/home"},
        {content: "State Codes", url: ""}]
    )
    const [triggerExportStateCodeDataQQuery] = useLazyExportStateCodeDataQuery();
    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'State Codes';
    }, []);

    const columns: DataTableColumn[] = [
        {
            label: "Name", accessor: "name", visibility: {hasShowSetting: false},
            cell: (props: any) => {
                let path = "/state-codes/" + props.row.original.id;
                return createClickableLink(path, props.value, userSetting, false, "", ["STATCODE-R"]);
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Name..."}
                                                     accessor={"name"}/>,
            }]
        },
    ]
    return (
        <div className="user-container px-5 py-5">
            <div className="flex justify-between">
                <Breadcrumb crumbs={crumbs}/>
            </div>
            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchAllStateCodesQuery,
                    exportAction: triggerExportStateCodeDataQQuery
                }}
                userSettingGroup={"StateCode"}
                defaultSortOptions={{
                    accessor: "name",
                    direction: "asc"
                }}
                buttonOptions={{
                    addButton:
                        {
                            button: <IconButton
                                icon={<FaPlus/>}
                                hasBackground={true}
                                onClick={() => {
                                    navigate("/state-codes/create")
                                }}
                                title={"Add State Code"}
                            />,
                            permissions: ["STATCODE-C"]
                        },
                }}
                basePermission={"STATCODE"}
            />
        </div>
    );
}

export default StateCodes;